import { get } from '@ember/helper';
import MatchHeader from './match-header';
import BanList from './ban-list';
import PlayerRow from './player-row';

// Build an item-image entry from its number (zero-padded already in the source list).
const item = (n) => {
  return { image: `/img/characters/loot/item-${n}.png`, alt: `item-${n}` };
};
const itemGroup = (...nums) => {
  return nums.map(item);
};
const skill = (n) => {
  return { image: `/img/characters/skills/skill-${n}.png`, alt: `skill-${n}` };
};
const char = (n) => {
  return { image: `/img/characters/${n}.png`, alt: `character-${n}` };
};

const teamABans = [char('09'), char('07'), char('10'), char('08'), char('06')];
const teamBBans = [char('03'), char('02'), char('04'), char('01'), char('05')];

const teamAMobilePlayers = [
  {
    image: '/img/characters/01.png',
    alt: 'character-01',
    color: 'blue',
    level: '16',
    skills: [skill('01'), skill('02')],
    gamertag: 'Joystickz-70',
    role: 'Mid | Solo',
    kda: ['9', '4', '8'],
    gold: '12934',
    cs: '183',
    wards: '0 25 2',
    killPct: '47',
    build: [itemGroup('01', '02', '03', '04'), itemGroup('05', '06', '07')],
  },
  {
    image: '/img/characters/02.png',
    alt: 'character-02',
    color: 'blue',
    level: '14',
    skills: [skill('03'), skill('04')],
    gamertag: 'Dr.Chaos',
    role: 'Bot | Support',
    kda: ['1', '6', '21'],
    gold: '9573',
    cs: '11',
    wards: '4 27 4',
    killPct: '61',
    build: [itemGroup('08', '09', '10', '11'), itemGroup('12', '13', '14')],
  },
  {
    image: '/img/characters/03.png',
    alt: 'character-03',
    color: 'blue',
    level: '16',
    skills: [skill('05'), skill('06')],
    gamertag: 'Firestorm',
    role: 'Bot | Carry',
    kda: ['11', '6', '10'],
    gold: '16109',
    cs: '267',
    wards: '1 11 3',
    killPct: '58',
    build: [itemGroup('22', '23', '24', '25'), itemGroup('27', '28', '29')],
  },
  {
    image: '/img/characters/04.png',
    alt: 'character-04',
    color: 'blue',
    level: '16',
    skills: [skill('07'), skill('08')],
    gamertag: 'DABLADE_NT',
    role: 'Top | Solo',
    kda: ['8', '5', '17'],
    gold: '12840',
    cs: '174',
    wards: '2 12 6',
    killPct: '69',
    build: [itemGroup('15', '16', '17', '18'), itemGroup('19', '20', '21')],
  },
  {
    image: '/img/characters/05.png',
    alt: 'character-05',
    color: 'blue',
    level: '14',
    skills: [skill('09'), skill('10')],
    gamertag: 'Keymaster',
    role: 'Jungle',
    kda: ['7', '6', '14'],
    gold: '11193',
    cs: '111',
    wards: '5 35 4',
    killPct: '58',
    build: [itemGroup('29', '30', '31', '32'), itemGroup('33', '34', '35')],
  },
];

const teamBMobilePlayers = [
  {
    image: '/img/characters/06.png',
    alt: 'character-06',
    color: 'red',
    level: '14',
    skills: [skill('11'), skill('12')],
    gamertag: 'Pixelus.GD',
    role: 'Bot | Carry',
    kda: ['7', '5', '3'],
    gold: '11973',
    cs: '211',
    wards: '1 10 9',
    killPct: '37',
    build: [itemGroup('08', '09', '10', '11'), itemGroup('12', '13', '14')],
  },
  {
    image: '/img/characters/07.png',
    alt: 'character-07',
    color: 'red',
    level: '12',
    skills: [skill('13'), skill('14')],
    gamertag: 'Striker15',
    role: 'Bot | Support',
    kda: ['2', '9', '4'],
    gold: '8913',
    cs: '57',
    wards: '4 22 7',
    killPct: '22',
    build: [itemGroup('01', '02', '03', '04'), itemGroup('05', '06', '07')],
  },
  {
    image: '/img/characters/08.png',
    alt: 'character-08',
    color: 'red',
    level: '14',
    skills: [skill('15'), skill('16')],
    gamertag: 'Arrowhead',
    role: 'Top | Solo',
    kda: ['3', '9', '9'],
    gold: '11148',
    cs: '178',
    wards: '2 12 4',
    killPct: '44',
    build: [itemGroup('29', '30', '31', '32'), itemGroup('33', '34', '35')],
  },
  {
    image: '/img/characters/09.png',
    alt: 'character-09',
    color: 'red',
    level: '15',
    skills: [skill('17'), skill('18')],
    gamertag: 'TheLightning',
    role: 'Mid | Solo',
    kda: ['8', '7', '6'],
    gold: '13218',
    cs: '207',
    wards: '3 8 6',
    killPct: '51',
    build: [itemGroup('22', '23', '24', '25'), itemGroup('27', '28', '29')],
  },
  {
    image: '/img/characters/10.png',
    alt: 'character-10',
    color: 'red',
    level: '13',
    skills: [skill('19'), skill('20')],
    gamertag: 'PXSlasher',
    role: 'Jungle',
    kda: ['7', '7', '9'],
    gold: '11189',
    cs: '156',
    wards: '2 26 7',
    killPct: '59',
    build: [itemGroup('15', '16', '17', '18'), itemGroup('19', '20', '21')],
  },
];

<template>
  <div class='v2 grid-limit layout-item'>
    <div class='widget-item'>
      <MatchHeader @teamA={{@teamA}} @teamB={{@teamB}} @match={{@match}} />
      <div class='table lineups full-stats full'>
        <div class='table-row-header big bordered colored'>
          <div class='table-row-header-item left'>
            <p class='table-row-header-title'>Character / Player</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K/D/A</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Gold</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>CS</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Wards</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K%</p>
          </div>
          <div class='table-row-header-item'></div>
          <div class='table-row-header-item'></div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K%</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Wards</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>CS</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Gold</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K/D/A</p>
          </div>
          <div class='table-row-header-item right'>
            <p class='table-row-header-title'>Character / Player</p>
          </div>
        </div>
        <div class='table-rows no-color'>
          {{#each @teamA.players as |player index|}}
            <div class='table-row big'>
              <div class='table-row-item'>
                <div class='team-info-wrap medium'>
                  <div class='user-avatar-wrap'>
                    <img class='user-avatar character v2 blue' src='{{player.photo.url}}' alt='character-01' />
                    <p class='user-avatar-text blue'>16</p>
                  </div>
                  <div class='skill-loot-list vertical'>
                    <img
                      class='skill-loot-item skill-loot-img'
                      src='/img/characters/skills/skill-01.png'
                      alt='skill-01'
                    />
                    <img
                      class='skill-loot-item skill-loot-img'
                      src='/img/characters/skills/skill-02.png'
                      alt='skill-02'
                    />
                  </div>
                  <div class='team-info'>
                    <p class='team-name'>{{player.gamertag}}</p>
                    <p class='team-country'>{{player.role}}</p>
                  </div>
                </div>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'><span class='highlight'>9</span>
                  /
                  <span class='highlight'>4</span>
                  /
                  <span class='highlight'>8</span></p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>12934</p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>183</p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>0 25 2</p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>47</p>
              </div>
              <div class='table-row-item'>
                <div class='skill-loot-list'>
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-01.png'
                    alt='item-01'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-02.png'
                    alt='item-02'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-03.png'
                    alt='item-03'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-04.png'
                    alt='item-04'
                  />
                </div>
                <div class='skill-loot-list'>
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-05.png'
                    alt='item-05'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-06.png'
                    alt='item-06'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-07.png'
                    alt='item-07'
                  />
                </div>
              </div>
              <div class='table-row-item'>
                <div class='skill-loot-list'>
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-08.png'
                    alt='item-08'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-09.png'
                    alt='item-09'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-10.png'
                    alt='item-10'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-11.png'
                    alt='item-11'
                  />
                </div>
                <div class='skill-loot-list'>
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-12.png'
                    alt='item-12'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-13.png'
                    alt='item-13'
                  />
                  <img
                    class='skill-loot-item skill-loot-img small'
                    src='/img/characters/loot/item-14.png'
                    alt='item-14'
                  />
                </div>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>37</p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>1 10 9</p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>211</p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'>11973</p>
              </div>
              <div class='table-row-item'>
                <p class='table-text bolder'><span class='highlight'>7</span>
                  /
                  <span class='highlight'>5</span>
                  /
                  <span class='highlight'>3</span></p>
              </div>
              <div class='table-row-item'>
                <div class='team-info-wrap medium inverted'>
                  <div class='user-avatar-wrap'>
                    <img
                      class='user-avatar character v2 red'
                      src='{{get (get @teamB.players index) "photo.url"}}'
                      alt='character-06'
                    />
                    <p class='user-avatar-text red'>14</p>
                  </div>
                  <div class='skill-loot-list vertical'>
                    <img
                      class='skill-loot-item skill-loot-img'
                      src='/img/characters/skills/skill-11.png'
                      alt='skill-11'
                    />
                    <img
                      class='skill-loot-item skill-loot-img'
                      src='/img/characters/skills/skill-12.png'
                      alt='skill-12'
                    />
                  </div>
                  <div class='team-info'>
                    <p class='team-name'>{{get (get @teamB.players index) 'gamertag'}}</p>
                    <p class='team-country'>{{get (get @teamB.players index) 'role'}}</p>
                  </div>
                </div>
              </div>
            </div>
          {{/each}}
        </div>
      </div>
      <div class='widget-row filled full'>
        <BanList @bans={{teamABans}} />
        <BanList @bans={{teamBBans}} @inverted={{true}} />
      </div>
      <div class='team-lineups-header medium mobile'>
        <div class='team-info-wrap mid'>
          <img class='team-logo mid' src='/img/teams/logos/01.png' alt='logo-01' />
          <div class='team-info'>
            <p class='team-name'>TLW | <span class='highlight team-blue'>Victory</span></p>
            <p class='team-country'>United States</p>
          </div>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon tower-icon blue'>
            <use href='#svg-tower'></use>
          </svg>
          <p class='featured-stat-title'>7</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon inhibitor-icon blue'>
            <use href='#svg-inhibitor'></use>
          </svg>
          <p class='featured-stat-title'>0</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon baron-icon blue'>
            <use href='#svg-baron'></use>
          </svg>
          <p class='featured-stat-title'>1</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon dragon-icon blue'>
            <use href='#svg-dragon'></use>
          </svg>
          <p class='featured-stat-title'>1</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon rift-herald-icon blue'>
            <use href='#svg-rift-herald'></use>
          </svg>
          <p class='featured-stat-title'>0</p>
        </div>
        <div class='featured-stat-wrap regular right'>
          <p class='featured-stat-title'><span class='highlight'>36</span>
            /
            <span class='highlight'>27</span>
            /
            <span class='highlight'>70</span></p>
          <p class='featured-stat-text'>K / D / A</p>
        </div>
      </div>
      <div class='table lineups full-stats mobile'>
        <div class='table-row-header big bordered colored'>
          <div class='table-row-header-item left'>
            <p class='table-row-header-title'>Character / Player</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K/D/A</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Gold</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>CS</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Wards</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K%</p>
          </div>
          <div class='table-row-header-item'></div>
        </div>
        <div class='table-rows no-color'>
          {{#each teamAMobilePlayers as |player|}}
            <PlayerRow @player={{player}} />
          {{/each}}
        </div>
      </div>
      <div class='widget-row filled mobile'>
        <BanList @bans={{teamABans}} />
      </div>
      <div class='team-lineups-header medium mobile'>
        <div class='team-info-wrap mid'>
          <img class='team-logo mid' src='/img/teams/logos/02.png' alt='logo-02' />
          <div class='team-info'>
            <p class='team-name'>RRH | <span class='highlight red'>Defeat</span></p>
            <p class='team-country'>South Africa</p>
          </div>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon tower-icon red'>
            <use href='#svg-tower'></use>
          </svg>
          <p class='featured-stat-title'>3</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon inhibitor-icon red'>
            <use href='#svg-inhibitor'></use>
          </svg>
          <p class='featured-stat-title'>0</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon baron-icon red'>
            <use href='#svg-baron'></use>
          </svg>
          <p class='featured-stat-title'>1</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon dragon-icon red'>
            <use href='#svg-dragon'></use>
          </svg>
          <p class='featured-stat-title'>2</p>
        </div>
        <div class='featured-stat-wrap multiple-items'>
          <svg class='featured-stat-icon rift-herald-icon red'>
            <use href='#svg-rift-herald'></use>
          </svg>
          <p class='featured-stat-title'>0</p>
        </div>
        <div class='featured-stat-wrap regular right'>
          <p class='featured-stat-title void'><span class='highlight'>27</span>
            /
            <span class='highlight'>37</span>
            /
            <span class='highlight'>31</span></p>
          <p class='featured-stat-text'>K / D / A</p>
        </div>
      </div>
      <div class='table lineups full-stats mobile'>
        <div class='table-row-header big bordered colored'>
          <div class='table-row-header-item left'>
            <p class='table-row-header-title'>Character / Player</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K/D/A</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Gold</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>CS</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>Wards</p>
          </div>
          <div class='table-row-header-item padded'>
            <p class='table-row-header-title'>K%</p>
          </div>
          <div class='table-row-header-item'></div>
        </div>
        <div class='table-rows no-color'>
          {{#each teamBMobilePlayers as |player|}}
            <PlayerRow @player={{player}} />
          {{/each}}
        </div>
      </div>
      <div class='widget-row filled mobile'>
        <BanList @bans={{teamBBans}} />
      </div>
    </div>
  </div>
</template>
